const { REACT_APP_BASE_BACKEND_URL } = process.env;

export const BASE_BACKEND_URL = `${REACT_APP_BASE_BACKEND_URL}`;
